import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// eslint-disable-next-line
import './index.scss';
export const DropdownWrapper = ({ className = '', children }) => {
	return <div className={`dropdown ${className}`}>{children}</div>;
};

DropdownWrapper.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string
};

export const DropdownToggle = ({ id, children, className, ...props }) => {
	return (
		<a
			className={`btn dropdown-toggle w-100 text-start ${className}`}
			href='#'
			role='button'
			id={id}
			data-bs-toggle='dropdown'
			aria-expanded='false'
			{...props}
		>
			{children}
		</a>
	);
};
DropdownToggle.propTypes = {
	children: PropTypes.node.isRequired,
	id: PropTypes.string.isRequired,
	className: PropTypes.string
};

export const DropdownMenu = ({ id, children }) => {
	return (
		<ul className='dropdown-menu' aria-labelledby={id} key={id}>
			{children.map((child, index) => (
				<li key={index}>{child}</li>
			))}
		</ul>
	);
};
DropdownMenu.propTypes = {
	children: PropTypes.node.isRequired,
	id: PropTypes.string.isRequired
};
export const DropdownItem = ({ as, to, children, ...props }) => {
	const Tag = as || 'a';
	return (
		<li>
			{Tag === 'a' ? (
				<Link to={to} className='dropdown-item'>
					{children}
				</Link>
			) : (
				<Tag className='dropdown-item' {...props}>
					{children}
				</Tag>
			)}
		</li>
	);
};
DropdownItem.propTypes = {
	children: PropTypes.node.isRequired,
	to: PropTypes.string,
	as: PropTypes.string
};
